
import React from 'react';

const LoadingOverlay = ({ loaderMessage }) => {
  return (
    <div style={styles.popupContainer}>
      <div style={styles.popupWrapper} />
      {loaderMessage}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  popupContainer: {
    position: 'absolute',
    top: 0,
    height: 60,
    width: '30%',
    background: '#fff',
    borderBottomRightRadius: 12,
    borderBottomLeftRadius: 12,
    zIndex: 9999,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    color: '#000'
  },
  popupWrapper: {
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #0078B2',
    borderRadius: '50%',
    width: 20,
    height: 20,
    animation: 'spin 1s linear infinite',
    marginRight: '10px',
  }
};

export default LoadingOverlay;